/**
 * Helpers for 15-minute HH:mm time option lists (same-calendar-day start/end pairs).
 */

export function hhMmToMinutes(hhMm) {
    if (!hhMm || !/^\d{2}:\d{2}$/.test(hhMm)) return null;
    const [h, m] = hhMm.split(":").map(Number);
    return h * 60 + m;
}

/** True when end is strictly after start (HH:mm, same day). */
export function isEndAfterStart(startHhMm, endHhMm) {
    if (!startHhMm || !endHhMm) return true;
    return endHhMm > startHhMm;
}

/**
 * Filter HH:mm strings: keep only times strictly after minTime and/or strictly before maxTime.
 */
export function filterHhMmTimes(times, { minTime, maxTime } = {}) {
    return times.filter((t) => {
        if (minTime && t <= minTime) return false;
        if (maxTime && t >= maxTime) return false;
        return true;
    });
}

/**
 * Filter { value, label } option objects with the same exclusive bounds.
 * If keepValue is set and would be filtered out, it is re-inserted so existing invalid data stays visible.
 */
export function filterTimeOptionObjects(options, { minTime, maxTime, keepValue } = {}) {
    let filtered = options.filter((opt) => {
        if (minTime && opt.value <= minTime) return false;
        if (maxTime && opt.value >= maxTime) return false;
        return true;
    });

    if (keepValue && !filtered.some((o) => o.value === keepValue)) {
        const existing = options.find((o) => o.value === keepValue);
        if (existing) {
            filtered = [...filtered, existing].sort((a, b) => a.value.localeCompare(b.value));
        }
    }

    return filtered;
}
